// src/components/atoms/Button/Button.js
import React from 'react';
import PropTypes from 'prop-types';
import styles from './modules/Button.module.scss';  // Make sure this import is correct

function Button({ text, onClick, className }) {
  return (
    <button className={`${styles.button} ${className}`} onClick={onClick}>
      {text}
    </button>
  );
}

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Button;
